import React, { useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import IntlTelInput from '@intl-tel-input/react/dist/IntlTelInputWithUtils.js';
import 'intl-tel-input/dist/css/intlTelInput.css';
import ErrorMessage from 'zignal-landscape/lib/ErrorMessage';

// ZEN-3071: international phone input. The widget formats as you type and reports
// an E.164 number; Bacon normalises with libphonenumber-js so both sides agree.
const PhoneInput = ({ id, value, onChange, disabled = false, error = null }) => {
  const validity = useRef(null);
  const number = useRef('');

  // The widget emits the number first and the validity second (and the validity only
  // when it changes), so report on both: the second report carries the settled validity.
  const handleValidity = useCallback((isValid) => {
    validity.current = isValid;
    onChange(number.current, isValid);
  }, [onChange]);
  const handleNumber = useCallback((next) => {
    number.current = next || '';
    onChange(number.current, validity.current);
  }, [onChange]);

  return (
    <div>
      <IntlTelInput
        value={value || ''}
        onChangeNumber={handleNumber}
        onChangeValidity={handleValidity}
        disabled={disabled}
        initialCountry="us"
        strictMode
        formatAsYouType
        inputProps={{ id, name: 'phone', 'data-cy': 'user-form-phone', autoComplete: 'off' }}
      />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </div>
  );
};

PhoneInput.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.string,
};

export default PhoneInput;
